var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfluence = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#confluence_svg__paint0_linear)",
  d: "M4.873 21.557c-.254.399-.544.87-.761 1.233a.765.765 0 0 0 .253 1.052l4.966 3.046a.764.764 0 0 0 1.051-.254c.181-.326.435-.761.725-1.233 1.957-3.227 3.95-2.865 7.503-1.16l4.929 2.321a.77.77 0 0 0 1.015-.363l2.356-5.331c.181-.363 0-.834-.363-1.016a153 153 0 0 1-4.929-2.357c-6.705-3.228-12.396-3.01-16.745 4.062"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#confluence_svg__paint1_linear)",
  d: "M27.127 9.443a59 59 0 0 0 .762-1.233.765.765 0 0 0-.254-1.052l-4.966-3.046a.764.764 0 0 0-1.05.254c-.182.326-.436.761-.726 1.233-1.957 3.228-3.95 2.865-7.503 1.16L8.462 4.44a.77.77 0 0 0-1.015.362L5.09 10.132c-.18.363 0 .834.363 1.016 1.05.471 3.117 1.45 4.93 2.357 6.704 3.192 12.395 3.01 16.744-4.062"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "confluence_svg__paint0_linear",
  x1: 26.791,
  x2: 11.792,
  y1: 28.467,
  y2: 19.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0052CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.918,
  stopColor: "#2380FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2684FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "confluence_svg__paint1_linear",
  x1: 5.209,
  x2: 20.208,
  y1: 2.523,
  y2: 11.136,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0052CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.918,
  stopColor: "#2380FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2684FF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfluence);
export default ForwardRef;